<template>
  <router-view></router-view>
</template>

<script>
import store from '@/store';

export default {
  name: 'Calendar',
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('fetchAllStrips').then(() => next());
  },
};
</script>
